var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Vue, Component, Emit, Prop } from 'vue-property-decorator';
import CheckApply from "~/components/visit-case/check-apply.vue";
import { Dependencies } from "~/core/decorator";
import { FlowTaskService } from "~/services/domain-service/flow-task.service";
import { CaseApplyRecordService } from "~/services/domain-service/case-apply-record.service";
import FileUpload from "~/components/common/file-upload.vue";
var ReductionApply = /** @class */ (function (_super) {
    __extends(ReductionApply, _super);
    function ReductionApply() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.dataForm = {
            confirm: 0,
            caseIds: [],
            applyCategory: '',
            derateAmount: '',
            fileIds: ''
        };
        _this.fileList = [];
        _this.checkMessages = {};
        _this.rules = {
            derateAmount: { required: true, message: "请输入申请减免金额" },
            applyDescription: { required: true, message: "请输入申请原因" },
        };
        _this.submitLoading = false;
        _this.dialog = false;
        return _this;
    }
    ReductionApply.prototype.emitClose = function () {
        this.resetDate();
    };
    /**
     * 提交
     */
    ReductionApply.prototype.commit = function () {
        var _this = this;
        var dataFrom = this.$refs["dataFrom"];
        dataFrom.validate(function (valid) {
            if (!valid)
                return false;
            _this.commitNext();
        });
    };
    /**
     * 检查案件
     */
    ReductionApply.prototype.commitNext = function () {
        var _this = this;
        this.flowTaskService
            .checkApplyCategory({ applyCategory: this.applyType })
            .subscribe(function (data) {
            // 0 拒绝，1 提示，2 通过
            if (data.status === 1) {
                _this.$confirm("该" +
                    _this.$dict.getDictName(_this.applyType, "ApplyCategory") +
                    "申请将直接生效，是否继续?", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning"
                })
                    .then(function () {
                    _this.submit();
                })
                    .catch(_this.error);
            }
            else if (data.status === 2) {
                _this.submit();
            }
        }, this.error);
    };
    /**
     * 提交接口调用
     */
    ReductionApply.prototype.submit = function () {
        this.submitLoading = true;
        this.dataForm.caseIds = this.caseIds;
        this.dataForm.applyCategory = this.applyType;
        this.dataForm.fileIds = this.fileList.map(function (v) { return v.response.id; });
        this.caseApplyRecordService
            .applyDerate(this.dataForm)
            .subscribe(this.success, this.error);
    };
    /**
     * 申请成功
     */
    ReductionApply.prototype.success = function (data) {
        if (data && data.status !== 2) {
            this.checkMessages = data;
            this.dialog = true;
        }
        else {
            this.submitLoading = false;
            this.$message.success("操作成功");
            this.emitClose();
        }
    };
    /**
     * 失败
     */
    ReductionApply.prototype.error = function () {
        this.submitLoading = false;
    };
    /**
     * 取消
     */
    ReductionApply.prototype.cancelContinue = function () {
        this.dialog = false;
        this.submitLoading = false;
    };
    /**
     * 继续提交
     */
    ReductionApply.prototype.confirmSubmit = function () {
        this.dataForm.confirm = 1;
        this.submit();
    };
    /**
     * 数据重置
     */
    ReductionApply.prototype.resetDate = function () {
        this.dataForm = {
            confirm: 0,
            caseIds: [],
            applyCategory: '',
            derateAmount: '',
            fileIds: ''
        };
        var form = this.$refs["dataFrom"];
        form.resetFields();
        this.checkMessages = {};
        this.fileList = [];
    };
    __decorate([
        Dependencies(FlowTaskService)
    ], ReductionApply.prototype, "flowTaskService", void 0);
    __decorate([
        Dependencies(CaseApplyRecordService)
    ], ReductionApply.prototype, "caseApplyRecordService", void 0);
    __decorate([
        Prop({ type: String })
    ], ReductionApply.prototype, "applyType", void 0);
    __decorate([
        Prop({ type: Array, required: true })
    ], ReductionApply.prototype, "caseIds", void 0);
    __decorate([
        Emit('close')
    ], ReductionApply.prototype, "emitClose", null);
    ReductionApply = __decorate([
        Component({
            components: {
                CheckApply: CheckApply,
                FileUpload: FileUpload
            }
        })
    ], ReductionApply);
    return ReductionApply;
}(Vue));
export default ReductionApply;
